import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { WorkerSeizureAmmount } from "../_types/worker-seizure-ammount";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class WorkerSeizuresAmmountsService extends Service<WorkerSeizureAmmount> {
    public override type = 'workerSeizuresAmmounts';
    public override url = 'invoicing/workerSeizuresAmmounts';

    public workerSeizureTotalAmmount(workerSeizureAmmountId: string): Observable<number> {
        let url = this.getAPIUrl()+"/workerSeizureTotalAmmount/" + workerSeizureAmmountId;
        return this.http.get<number>(url);
      }
  
}
